__turbopack_context__.v({
  "styledLink": "IconLink-module__q84CYW__styledLink",
});
